import { defineStore } from "pinia";

export const useTourStore = defineStore("tour", {
    state: () => {
        return {
            tours: [],
        };
    },
    getters: {
        //
    },
    actions: {
        setup() {
            this.getTours();
        },
        getTours() {
            return axios
                .get("/api/tours")
                .then((tours) => {
                    this.tours = tours.data;
                })
                .catch((error) => {
                    console.error(error);
                });
        },
    },
});
